import React, { useMemo } from "react";
import MirsTable from "components/general/table/Table";
//General
import { TableColumnsSummary as ColumnSummary } from 'components/sports/swm/events/individual/results/Columns'
import { useViewport } from 'components/general/useViewPort';


const GetConfiguration = (data, breakPoint) => {
    const columnsAdded = data?.config?.extendedConfig ? data.config.extendedConfig.sort((a, b) => a.pos - b.pos) : []
    let showQualMark = data?.items?.some(item => item.qualificationMark);
    let showRecords = data?.items?.some(item => item.recordIndicators);
    let configuration = {
        caption: null,
        columns: [],
        hiddenColumns: [],
        sortBy: [],
        filters: {
            ei_type: ['NONE'],
            ei_code: ['NONE']
        },
        configs: {
            columnsAdded: columnsAdded,
            previousCurrent: false,
        }
    };

    if (!showQualMark)
        configuration.hiddenColumns.push('QualMark')
    if (!showRecords)
        configuration.hiddenColumns.push('Records')

    if (breakPoint === 'sm' || breakPoint === 'xs')
        configuration.hiddenColumns.push('Diff')

    configuration.sortBy = [{ id: 'rankSum', desc: false }]
    configuration.columns = ColumnSummary(columnsAdded)
    return configuration;
};


const SwmSumResults = ({ data }) => {
    const { breakPoint } = useViewport()
    const resultStatus = data?.results?.status?.code;
    const rsc = data?.results?.eventUnitCode;

    //Cuando cambimos de estado de resultados forzamos a repintar la tabla con las nuevas columnas 
    //aunque no hay cambios    
    // eslint-disable-next-line
    const configEvent = useMemo(() => GetConfiguration(data, breakPoint), [resultStatus, breakPoint]);
    return (
        <>
            {data?.items
                ? (
                    <>
                        < MirsTable
                            //Dato to show by row
                            data={data.items}
                            //Columnas a visualizar 
                            columns={configEvent.columns}
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            //Columns to hidde 
                            hiddenColumns={configEvent.hiddenColumns}
                            sortable={false}
                            //When show tble is sorted by 
                            initialSortBy={configEvent.sortBy}
                            id={`mirs-table-result-${rsc}`}
                        />

                    </>
                ) : (
                    ''
                )
            }
        </>
    );
};

export default SwmSumResults;
